// You can create common utility functions here as mixin which can be used in your components
import { mapGetters } from "vuex";
import { UserGroup } from "@/services/UserGroups";
// @group Mixins
export default {
  computed: {
    ...mapGetters(["userGroups"])
  },
  data() {
    return { showDelete: true, showEdit: true, kpiYear: null };
  },

  methods: {
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    checkExternalPermission() {
      const switchCustomerData = this.fetchSwitchCustomerCache();
      if (
        this.userGroups.includes(UserGroup.EXTERNAL_USER) ||
        switchCustomerData
      ) {
        this.$router.push({ name: "home" });
      }
    },
    yearList() {
      // generate list of the year from current year
      const current_Year = new Date().getFullYear() + 1;

      const years = [];
      for (let i = current_Year; i >= 2000; i--) {
        years.push(i);
      }
      return years;
    },
    currentYear() {
      return new Date().getFullYear();
    },
    currentDate() {
      const today = new Date();
      return today;
    },
    firstDayOfYear() {
      const firstDay = new Date(new Date().getFullYear(), 0, 1);
      return firstDay;
    },
    sixMonthsBefore() {
      const today = new Date();
      today.setMonth(today.getMonth() - 6);
      return today;
    },
    dateFormatter(dt) {
      // Format or convert b-datepicker DateTime to string date
      if ((dt != null) & (dt != "")) {
        return dt.toLocaleDateString("fr-CA");
      }
      return dt;
    },
    dateFormatterNew(dt) {
      // Format or convert b-datepicker DateTime to string date
      if ((dt != null) & (dt != "")) {
        return dt.toLocaleDateString("fr-CA");
      }
      return dt;
    },

    dateToLocalDate(dt) {
      return new Date(dt).toLocaleString([], {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true
      });
    },

    fetchSwitchCustomerCache() {
      /**
       * Fetching switch customer data from localstorage
       */
      let switchCustomerData = null;
      const switchCustomerCache = localStorage.getItem("switchCustomerView");
      if (switchCustomerCache != null) {
        switchCustomerData = JSON.parse(switchCustomerCache);
      }
      return switchCustomerData;
    },

    disableActionItem() {
      if (this.$route.fullPath.includes("/view/")) {
        this.showDelete = false;
        this.showEdit = false;
        return false;
      } else {
        return true;
      }
    }
  }
};
